import React, { useEffect, useRef } from "react";
import { getStyles, toAppUrl } from "../../../assets/js/utils/functions";
import { AppBtn } from "../../ui/buttons";
import Typed from "typed.js";
import dynamic from "next/dynamic";
import { getSizedImage } from "../../../assets/js/utils/utils";
import useScreenSize, { BreakPoint } from "../../hooks/useScreenSize";
import LazyImage from "../../lazy-image";
import Portal from "../../portal";
import { useModals } from "../../hooks/useModals";

const FrontPagesHeader = dynamic(() => import("../commons/header"), { ssr: true });
const FrontPagesVideoPlayer = dynamic(() => import("../commons/video-player"), { ssr: true });

const StoreLinksHeader = () => {
  const { screen } = useScreenSize();

  return (
    <FrontPagesHeader
      followText="Store links helps you beautifully showcase all your products and get orders on whatsapp."
      ctas={<CTAs />}
      heroContent={
        <div className="w-[200%] sm:w-full pt-[125%] sm:pt-[61%] relative">
          <LazyImage
            src={getSizedImage(
              "https://res.cloudinary.com/catlog/image/upload/v1670559710/front-pages/mockups/store-front-whatsapp.webp",
              { [BreakPoint.xs]: "w_1500", default: "w_2025" },
              screen
            )}
            showLoader={false}
            className="w-full block hero-image-with-shadow absolute top-0"
            alt="Store links and merchant's whatsapp mockup"
          />
        </div>
      }
    >
      <div className="words-line">
        <span className="anim-word-up inline-block">Take</span>{" "}
        <span className="anim-word-up inline-block" style={getStyles({ "--delay": "0.15s" })}>
          Orders
        </span>{" "}
        <span className="anim-word-up inline-block" style={getStyles({ "--delay": "0.3s" })}>
          Via
        </span>{" "}
        <span className="anim-word-up inline-block" style={getStyles({ "--delay": "0.45s" })}>
          Chat
        </span>{" "}
      </div>{" "}
      <div className="words-line font-bold text-primary-500">
        <span className="anim-word-up inline-block !leading-tight" style={getStyles({ "--delay": "0.6s" })}>
          With One Link
        </span>
      </div>{" "}
    </FrontPagesHeader>
  );
};

const CTAs = () => {
  const { modals, toggleModal } = useModals(["video"]);
  return (
    <>
      <AppBtn size="lg" className="!font-semibold" href={toAppUrl("app/sign-up")}>
        Start using links
        {/* prettier-ignore */}
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="ml-1.5 transform transition-all ease-out duration-100 group-hover:translate-x-0.5">
          <path d="M6 0L4.9425 1.0575L9.1275 5.25H0V6.75H9.1275L4.9425 10.9425L6 12L12 6L6 0Z" fill="white" />
        </svg>
      </AppBtn>
      <AppBtn
        size="lg"
        color="white"
        className="border border-grey-outline border-opacity-20 !text-black !font-semibold"
        onClick={() => toggleModal("video")}
      >
        See how it works
        {/* prettier-ignore */}
        <svg viewBox="0 0 22 22" fill="none" className="w-4.5 sm:w-5 md:w-[22px] ml-1.5">
          <path d="M8.33984 10.9999V9.6432C8.33984 7.89237 9.57734 7.18654 11.0898 8.05737L12.2632 8.7357L13.4365 9.41404C14.949 10.2849 14.949 11.7149 13.4365 12.5857L12.2632 13.264L11.0898 13.9424C9.57734 14.8132 8.33984 14.0982 8.33984 12.3565V10.9999Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.9987 20.1663C16.0613 20.1663 20.1654 16.0623 20.1654 10.9997C20.1654 5.93706 16.0613 1.83301 10.9987 1.83301C5.93609 1.83301 1.83203 5.93706 1.83203 10.9997C1.83203 16.0623 5.93609 20.1663 10.9987 20.1663Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </AppBtn>
      <Portal>
        <FrontPagesVideoPlayer show={modals.video} toggle={() => toggleModal("video")} ytVideoId="lBHhOtG3wL8" />
      </Portal>
    </>
  );
};

export default StoreLinksHeader;
